import React, { useState } from "react";
import {
  Box,
  Heading,
  Input,
  VStack,
  HStack,
  Divider,
  Text,
  IconButton,
  Tooltip,
  useBreakpointValue,
  ButtonGroup,
  Button,
  Flex,
  Icon,
  Select,
} from "@chakra-ui/react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import {
  FaSortAmountUp,
  FaSortAmountDown,
  FaChartBar,
  FaList,
  FaClock,
} from "react-icons/fa";
import UserList from "./UserList";
import UserDetails from "./UserDetails";
import TimesheetDashboard from "../TimesheetAnalysis/TimesheetDashboard";
import { IconWrapper } from "../../../components/IconWrapper";

Chart.register(...registerables);

type FlexDirection = "row" | "row-reverse" | "column" | "column-reverse";

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  phone: string;
  assignedProjects?: string[];
  assignedTasks?: { id: string; name: string }[];
  organizationId: string;
  permissions?: "Admin" | "Editor" | "Viewer";
};

interface UserPerformanceProps {
  organizationId: string;
  users: User[];
  color: string;
  bg: string;
  currentUser?: any;
}

const UserPerformance: React.FC<UserPerformanceProps> = ({
  organizationId,
  users,
  color,
  bg,
  currentUser,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTimesheetUser, setSelectedTimesheetUser] =
    useState<User | null>(null);
  {/* Commented out states for other tabs and performance view */}
  {/* const [selectedUser, setSelectedUser] = useState<User | null>(null); */}
  {/* const [activeTab, setActiveTab] = useState(0); */}
  {/* const [viewType, setViewType] = useState<"projects" | "tasks">("projects"); */}
  {/* const [timesheetUserId, setTimesheetUserId] = useState<string | null>(null); */}

  const iconSize = useBreakpointValue({ base: "sm", md: "md" });
  const inputWidth = useBreakpointValue({ base: "100%", md: "40%" });
  const layoutDirection: FlexDirection =
    useBreakpointValue({ base: "column", md: "row" }) || "column";

  const filteredUsers = users.filter(
    (user) =>
      user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  {/* Commented out performance calculations */}
  {/* const sortedUsers = [...filteredUsers].sort(
    (a, b) =>
      (b.assignedProjects?.length || 0) - (a.assignedProjects?.length || 0)
  ); */}

  {/* const mostAssignedUser = sortedUsers[0]; */}
  {/* const leastAssignedUser = sortedUsers[sortedUsers.length - 1]; */}

  {/* Commented out dynamic chart data */}
  {/* const chartData = {
    labels: filteredUsers.map((user) => `${user.firstName} ${user.lastName}`),
    datasets: [
      {
        label: viewType === "projects" ? "Assigned Projects" : "Assigned Tasks",
        data: filteredUsers.map((user) =>
          viewType === "projects"
            ? user.assignedProjects?.length || 0
            : user.assignedTasks?.length || 0
        ),
        backgroundColor:
          viewType === "projects"
            ? "rgba(54, 162, 235, 0.6)"
            : "rgba(255, 99, 132, 0.6)",
        borderColor:
          viewType === "projects"
            ? "rgba(54, 162, 235, 1)"
            : "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  }; */}

  return (
    <Box width="100%" flex="1" minH="0" display="flex" flexDirection="column" bg={bg}>
      {/* Commented out heading based on active tab */}
      {/* {activeTab !== 0 && (
        <Heading fontSize="xl" mb={4} textAlign="center" color={color}>
          User Performance Analysis
        </Heading>
      )} */}

{ /*  <HStack
        justify="space-between"
        flexDirection={layoutDirection}
        gap={4}
        mt={-2}
      >
    {!selectedTimesheetUser && activeTab === 0? ( 
       //   <Heading fontSize="xl" mb={2} color={color}>
       //     TimeSheets
      //    </Heading>
      //  ) : (
       //   <>
        //    <Text></Text>
        //  </>
          // <Input
          //   color={color}
          //   placeholder="Search users..."
          //   width={inputWidth}
          //   onChange={(e) => setSearchTerm(e.target.value)}
          // />
      //  )}

        {/* Commented out tab selection buttons */}
        {/* {!selectedTimesheetUser && (
          <HStack spacing={3}>
            <Tooltip label="Timesheet Analysis">
              <IconButton
                aria-label="Timesheet View"
                icon={<IconWrapper icon={FaClock} size={16} />}
                size={"sm"}
                colorScheme={activeTab === 0 ? "purple" : "gray"}
                onClick={() => setActiveTab(0)}
              />
            </Tooltip>
            <Tooltip label="Performance Chart">
              <IconButton
                size={"sm"}
                aria-label="Chart View"
                icon={<IconWrapper icon={FaChartBar} size={16} />}
                colorScheme={activeTab === 1 ? "purple" : "gray"}
                onClick={() => setActiveTab(1)}
              />
            </Tooltip>
          </HStack>
        )} 
      </HStack> 
      */}
      {/* Commented out performance stats section */}
      {/* {activeTab !== 0 && (
        <VStack spacing={4} align="stretch" my={4}>
          <HStack justify="space-between">
            <HStack>
              <IconWrapper
                icon={FaSortAmountUp}
                size={16}
                className="text-green-500"
              />
              <Text
                color={color}
                fontWeight="bold"
                fontSize={{ base: "sm", md: "md" }}
              >
                Most Assigned: {mostAssignedUser?.firstName}{" "}
                {mostAssignedUser?.lastName} (
                {mostAssignedUser?.assignedProjects?.length || 0})
              </Text>
            </HStack>
            <HStack>
          
              <IconWrapper
                icon={FaSortAmountDown}
                size={16}
                className="text-red-500"
              />{" "}
              <Text
                color={color}
                fontWeight="bold"
                fontSize={{ base: "sm", md: "md" }}
              >
                Least Assigned: {leastAssignedUser?.firstName}{" "}
                {leastAssignedUser?.lastName} (
                {leastAssignedUser?.assignedProjects?.length || 0})
              </Text>
            </HStack>
          </HStack>
        </VStack>
      )} */}

      {/* {!selectedTimesheetUser && <Divider my={4} />} */}

      {/* Commented out Tabs structure, keeping only TimesheetDashboard */}
      {/* <Tabs
        variant="soft-rounded"
        colorScheme="blue"
        index={activeTab}
        onChange={setActiveTab}
      >
        <TabList display="none">
          <Tab>Timeline</Tab>
          <Tab>Chart</Tab>
        </TabList>

        <TabPanels> */}

          <TimesheetDashboard
            color={color}
            bg={bg}
            organizationId={organizationId}
            users={users}
            selectedUser={selectedTimesheetUser}
            setSelectedUser={setSelectedTimesheetUser}
            currentUser={currentUser}
          />

        {/* </TabPanels>
      </Tabs> */}
    </Box>
  );
};

export default UserPerformance;
